/**
 * Challenge store — controls create sheet visibility and editing state.
 */

import { create } from 'zustand'
import type { Challenge } from '@turnifly/shared/types'

type ChallengeType = 'private' | 'public' | 'competition'

interface GoalContext {
  goalId: string
  goalName: string
  goalUnit: string
  goalTarget: number
}

interface ChallengeState {
  isCreateOpen: boolean
  selectedType: ChallengeType | null
  editingChallenge: Challenge | null
  addHabitChallengeId: string | null
  goalContext: GoalContext | null
  setCreateOpen: (open: boolean) => void
  setSelectedType: (type: ChallengeType | null) => void
  setEditingChallenge: (challenge: Challenge | null) => void
  setAddHabitChallengeId: (id: string | null) => void
  setGoalContext: (ctx: GoalContext | null) => void
  openFromGoal: (ctx: GoalContext) => void
  reset: () => void
}

export const useChallengeStore = create<ChallengeState>()((set) => ({
  isCreateOpen: false,
  selectedType: null,
  editingChallenge: null,
  addHabitChallengeId: null,
  goalContext: null,
  setCreateOpen: (isCreateOpen) => set({ isCreateOpen }),
  setSelectedType: (selectedType) => set({ selectedType }),
  setEditingChallenge: (editingChallenge) => set({
    editingChallenge,
    isCreateOpen: !!editingChallenge,
    selectedType: editingChallenge?.type as ChallengeType ?? null,
  }),
  setAddHabitChallengeId: (addHabitChallengeId) => set({ addHabitChallengeId }),
  setGoalContext: (goalContext) => set({ goalContext }),
  openFromGoal: (ctx) => set({
    goalContext: ctx,
    isCreateOpen: true,
    selectedType: 'private',
  }),
  reset: () => set({
    isCreateOpen: false,
    selectedType: null,
    editingChallenge: null,
    addHabitChallengeId: null,
    goalContext: null,
  }),
}))
